import { render, staticRenderFns } from "./BidsView.vue?vue&type=template&id=4dfedfe1&scoped=true"
import script from "./BidsView.vue?vue&type=script&lang=js"
export * from "./BidsView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4dfedfe1",
  null
  
)

export default component.exports